import type { ErrorEvent, EventHint } from '@sentry/angular';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * Drops aborted / offline HTTP requests (status 0) before they reach Sentry.
 * These bubble up as `Error: undefined` because the Sentry SDK can't unwrap
 * `HttpErrorResponse`, and they're already handled by the offline UX path.
 */
export const sentryBeforeSend = (event: ErrorEvent, hint: EventHint): ErrorEvent | null => {
	const original = hint.originalException;
	if (original instanceof HttpErrorResponse && original.status === 0) {
		return null;
	}
	return event;
};
